import { render, staticRenderFns } from "./AStepItem.vue?vue&type=template&id=4b0d17ae&scoped=true"
import script from "./AStepItem.vue?vue&type=script&lang=js"
export * from "./AStepItem.vue?vue&type=script&lang=js"
import style0 from "./AStepItem.vue?vue&type=style&index=0&id=4b0d17ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d17ae",
  null
  
)

export default component.exports